export const INIT_REGION_LIST_REQUEST = 'INIT_REGION_LIST_REQUEST';
export const SET_REGION_LIST = 'SET_REGION_LIST';
export const ERROR_REGION_LIST = 'ERROR_REGION_LIST';
export const ADD_REGION = 'ADD_REGION';
export const ERROR_REGION = 'ERROR_REGION';
export const SET_REGION = 'SET_REGION';
export const UPDATE_REGION = 'UPDATE_REGION';
export const DELETE_REGION = 'DELETE_REGION';

export function initRegionListRequest() {
  return { type: INIT_REGION_LIST_REQUEST };
}

export function setRegionList(data) {
  return { type: SET_REGION_LIST, payload: data };
}

export function errorRegionList(error) {
  return { type: ERROR_REGION_LIST, payload: error };
}

export function addRegion(region) {
  return { type: ADD_REGION, payload: region };
}

export function errorRegion(data) {
  return { type: ERROR_REGION, payload: data };
}

export function setRegion(data) {
  return { type: SET_REGION, payload: data };
}

export function updateRegion(region) {
  return { type: UPDATE_REGION, payload: region };
}

export function deleteRegion(id) {
  return { type: DELETE_REGION, payload: id };
}
